export default __webpack_public_path__ + "static/media/NoTimeline.162ad7ad.svg";